/**
 * Класс реализует базовую логику для компонента report-selector
 */
class CReportSelector {
}

module.exports = CReportSelector;
